import { PNL_EMPTY_VALIDATION, PNL_ERROR, PNL_HIDE_EMPTY_VALIDATION, PNL_HIDE_ERROR, PNL_REPORT, PNL_SHOW_SHIMMER, PNL_STOCK_DETAILS, PNL_STREAM_TOGGLE, PROD_ASSET_FILTER_VAL, } from "../../interfaces/Reports/iPNLReport";
const initState = {
    data: {
        PnLData: {
            pnLSummary: {
                totalPnl: "0",
                totalPnlChangePercent: "0",
                realisedPnl: "0",
                realisedPnlChangePercent: "0",
                unrealisedPnl: "0",
                unrealisedPnlChangePercent: "0",
                closePriceDate: "",
                totalMarketValue: "",
                totalClosingCostValue: "",
                totalSellCostValue: "",
                editableCount: 0,
                totalInvestment: "0",
                totalSellValue: "0",
                daysPnLChange: "0",
            },
            pnLDetails: [],
            pnlDataFlags: { bodProcessInfoMessage: "", isBodEnabled: false }
        },
        SearchData: "",
        FilterData: null,
        SortData: [],
        IsSummarize: false,
    },
    selectedStockDetails: {
        tradeDetails: null,
        transactionType: null,
        assetType: null,
        fromDate: "",
        toDate: "",
        edelweissProductCode: null
    },
    downloadStatus: {
        error: null,
        isOpen: null,
    },
    emailStatus: {
        error: null,
        isOpen: null,
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
    showShimmer: false,
    prodDropDown: null,
    stream: false,
};
const pnlReport = (state = initState, action) => {
    switch (action.type) {
        case PNL_REPORT:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case PNL_STOCK_DETAILS:
            return Object.assign(Object.assign({}, state), { selectedStockDetails: action.payload.selectedStockDetails });
        case PNL_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case PNL_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initState[action.errorType] });
        case PNL_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case PNL_HIDE_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: Object.assign({}, initState.emptyValidation) });
        case PNL_SHOW_SHIMMER:
            return Object.assign(Object.assign({}, state), { showShimmer: action.payload.showShimmer });
        case PROD_ASSET_FILTER_VAL:
            return Object.assign(Object.assign({}, state), { prodDropDown: action.payload.prodDropDown });
        case PNL_STREAM_TOGGLE:
            return Object.assign(Object.assign({}, state), { stream: action.payload.stream });
        default:
            return Object.assign({}, state);
    }
};
export default pnlReport;
